const getScholarDescription = (scholar, index) => {
  const group1 = [
    "{name} {position} at {institution}. {name}’s research interests include {keywords}. {name} frequently publishes at the this venue conference, with at least {publication_count} influential papers and more than {citation_count} citations.",
    "{name} {position} at {institution}. {name}’s research interests include {keywords}. {name} is an active researcher, regularly contributing to the this venue conference with at least {publication_count} significant papers and over {citation_count} citations.",
    "{name} {position} at {institution}. {name}’s research interests include {keywords}. {name} has a strong presence at the this venue conference, having published at least {publication_count} notable papers and papers over {citation_count} citations.",
    "{name} {position} at {institution}. {name}’s research interests include {keywords}. {name} is a prolific author, contributing frequently to the this venue conference with at least {publication_count} influential papers and more than {citation_count} citations.",
  ];

  const group2 = [
    "{name} {position} at {institution}. {name}’s research interests include {keywords}. {name} frequently presents his work at the this venue conference, boasting at least {publication_count} influential papers and exceeding {citation_count} citations.",
    "{name} {position} at {institution}. {name}’s research interests include {keywords}. {name} has made substantial contributions to the this venue conference, with at least {publication_count} published influential papers and over {citation_count} citations.",
    "{name} {position} at {institution}. {name}’s research interests include {keywords}. {name} actively contributes to the this venue conference, with at least {publication_count} significant papers and a citation count surpassing {citation_count}.",
    "{name} {position} at {institution}. {name}’s research interests include {keywords}. {name} has an established track record at the this venue conference, with at least {publication_count} noteworthy papers and more than {citation_count} citations.",
  ];

  const getRes = (str, scholar) => {
    const res = str
      .replaceAll("{name}", scholar?.name || "?")
      .replaceAll(
        "{position}",
        scholar?.position ? `serves as ${scholar?.position}` : "works"
      )
      .replaceAll("{institution}", scholar?.institution.name || "?")
      .replaceAll(
        "{keywords}",
        scholar.keywords
          .map((e) => e.value)
          .slice(0, 3)
          .join(", ") || "?"
      )
      .replaceAll(
        "{publication_count}",
        scholar?.specific_stats.publication_count || "?"
      )
      .replaceAll(
        "{citation_count}",
        scholar?.specific_stats.citation_count || "?"
      );
    return res;
  };

  return getRes(
    index % 2 === 0
      ? group1[Math.floor(Math.random() * group1.length)]
      : group2[Math.floor(Math.random() * group2.length)],
    scholar
  );
};

export default getScholarDescription;
